(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7811],{

/***/ 44174:
/***/ (function(module) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),

/***/ 81119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),

/***/ 89881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(47816),
    createBaseEach = __webpack_require__(99291);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 47816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(28483),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 69199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881),
    isArrayLike = __webpack_require__(98612);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 82689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseIteratee = __webpack_require__(67206),
    baseMap = __webpack_require__(69199),
    baseSortBy = __webpack_require__(71131),
    baseUnary = __webpack_require__(7518),
    compareMultiple = __webpack_require__(85022),
    identity = __webpack_require__(6557);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 71131:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 26393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 85022:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(26393);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 55189:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(44174),
    baseAggregator = __webpack_require__(81119),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),

/***/ 99291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 7739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    createAggregator = __webpack_require__(55189);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 89734:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078),
    baseOrderBy = __webpack_require__(82689),
    baseRest = __webpack_require__(5976),
    isIterateeCall = __webpack_require__(16612);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 44908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseUniq = __webpack_require__(45652);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ 76502:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/products",
      function () {
        return __webpack_require__(35861);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36822);






var Image = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var ratio = _param.ratio, _disabledEffect = _param.disabledEffect, disabledEffect = _disabledEffect === void 0 ? false : _disabledEffect, _effect = _param.effect, effect = _effect === void 0 ? "blur" : _effect, sx = _param.sx, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "ratio",
        "disabledEffect",
        "effect",
        "sx"
    ]);
    var content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        component: react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__.LazyLoadImage,
        wrapperClassName: "wrapper",
        effect: disabledEffect ? undefined : effect,
        placeholderSrc: disabledEffect ? "/assets/transparent.png" : "/assets/placeholder.svg",
        sx: {
            width: 1,
            height: 1,
            objectFit: "cover"
        }
    }, other));
    if (ratio) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            ref: ref,
            component: "span",
            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                width: 1,
                lineHeight: 1,
                display: "block",
                overflow: "hidden",
                position: "relative",
                pt: getRatio(ratio),
                "& .wrapper": {
                    top: 0,
                    left: 0,
                    width: 1,
                    height: 1,
                    position: "absolute",
                    backgroundSize: "cover !important"
                }
            }, sx),
            children: content
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        ref: ref,
        component: "span",
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            lineHeight: 1,
            display: "block",
            overflow: "hidden",
            position: "relative",
            "& .wrapper": {
                width: 1,
                height: 1,
                backgroundSize: "cover !important"
            }
        }, sx),
        children: content
    });
});
function getRatio() {
    var ratio = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1/1";
    return ({
        "4/3": "calc(100% / 4 * 3)",
        "3/4": "calc(100% / 3 * 4)",
        "6/4": "calc(100% / 6 * 4)",
        "4/6": "calc(100% / 4 * 6)",
        "16/9": "calc(100% / 16 * 9)",
        "9/16": "calc(100% / 9 * 16)",
        "21/9": "calc(100% / 21 * 9)",
        "9/21": "calc(100% / 9 * 21)",
        "1/1": "100%"
    })[ratio];
}
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 50853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SkeletonImageItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88078);
// @mui


// ----------------------------------------------------------------------
function SkeletonImageItem() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        item: true,
        xs: 12,
        sm: 6,
        md: 4,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            container: true,
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 330
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 50,
                            borderRadius: 1
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        variant: "rectangular",
                        width: "100%",
                        sx: {
                            height: 150,
                            borderRadius: 1
                        }
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 96339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MD": function() { return /* reexport */ SkeletonImage/* default */.Z; },
  "VJ": function() { return /* reexport */ SkeletonPost; },
  "M2": function() { return /* reexport */ SkeletonPostItem; },
  "Ti": function() { return /* reexport */ SkeletonProduct; },
  "JJ": function() { return /* reexport */ SkeletonProductItem; }
});

// UNUSED EXPORTS: SkeletonConversationItem, SkeletonKanbanColumn, SkeletonMailSidebarItem, SkeletonMap

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonMap.tsx
// @mui



// ----------------------------------------------------------------------
function SkeletonMap() {
    return /*#__PURE__*/ _jsx(Stack, {
        spacing: 8,
        children: _to_consumable_array(Array(5)).map(function(_, index) {
            return /*#__PURE__*/ _jsx(Skeleton, {
                variant: "rectangular",
                sx: {
                    width: 1,
                    height: 560,
                    borderRadius: 2
                }
            }, index);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton_Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(36822);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonPost.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonPost() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                width: "100%",
                height: 560,
                variant: "rectangular",
                sx: {
                    borderRadius: 2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    mt: 3,
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        width: 64,
                        height: 64
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        sx: {
                            flexGrow: 1,
                            ml: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                height: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                height: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                height: 20
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonProduct.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonProduct() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 6,
                lg: 7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: "100%",
                    sx: {
                        paddingTop: "100%",
                        borderRadius: 2
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                md: 6,
                lg: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        width: 80,
                        height: 80
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 240
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        height: 40
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonPostItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonPostItem() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sm: 6,
        md: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                sx: {
                    height: 200,
                    borderRadius: 2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                sx: {
                    display: "flex",
                    mt: 1.5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "circular",
                        sx: {
                            width: 40,
                            height: 40
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        sx: {
                            mx: 1,
                            flexGrow: 1
                        }
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack_Stack = __webpack_require__(26447);
;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonProductItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonProductItem() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                variant: "rectangular",
                sx: {
                    paddingTop: "100%"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                spacing: 2,
                sx: {
                    p: 3
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                        variant: "text",
                        sx: {
                            width: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_Stack/* default */.Z, {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        sx: {
                                            width: 16,
                                            height: 16
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        sx: {
                                            width: 16,
                                            height: 16
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                        variant: "circular",
                                        sx: {
                                            width: 16,
                                            height: 16
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_Skeleton/* default */.Z, {
                                variant: "text",
                                sx: {
                                    width: 40
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonKanbanColumn.tsx
// @mui



// ----------------------------------------------------------------------
function SkeletonKanbanColumn() {
    return /*#__PURE__*/ _jsx(Box, {
        sx: {
            display: "grid",
            gap: 3,
            gridTemplateColumns: "repeat(4, 1fr)"
        },
        children: _to_consumable_array(Array(3)).map(function(_, index) {
            return /*#__PURE__*/ _jsx(Paper, {
                variant: "outlined",
                sx: {
                    p: 2.5,
                    width: 310
                },
                children: /*#__PURE__*/ _jsxs(Stack, {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ _jsx(Skeleton, {
                            variant: "rectangular",
                            sx: {
                                paddingTop: "75%",
                                borderRadius: 1.5
                            }
                        }),
                        index === 0 && /*#__PURE__*/ _jsx(Skeleton, {
                            variant: "rectangular",
                            sx: {
                                paddingTop: "25%",
                                borderRadius: 1.5
                            }
                        }),
                        index !== 2 && /*#__PURE__*/ _jsx(Skeleton, {
                            variant: "rectangular",
                            sx: {
                                paddingTop: "25%",
                                borderRadius: 1.5
                            }
                        })
                    ]
                })
            }, index);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonMailSidebarItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonMailSidebarItem() {
    return /*#__PURE__*/ _jsxs(Stack, {
        spacing: 1,
        direction: "row",
        alignItems: "center",
        sx: {
            px: 3,
            py: 1
        },
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "circular",
                width: 32,
                height: 32
            }),
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "text",
                sx: {
                    width: 0.25,
                    height: 16
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/skeleton/SkeletonConversationItem.tsx
// @mui


// ----------------------------------------------------------------------
function SkeletonConversationItem() {
    return /*#__PURE__*/ _jsxs(Stack, {
        spacing: 1,
        direction: "row",
        alignItems: "center",
        sx: {
            px: 3,
            py: 1.5
        },
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                variant: "circular",
                width: 48,
                height: 48
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 0.5,
                sx: {
                    flexGrow: 1
                },
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "text",
                        sx: {
                            width: 0.5,
                            height: 16
                        }
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "text",
                        sx: {
                            width: 0.25,
                            height: 12
                        }
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/skeleton/SkeletonImage.tsx
var SkeletonImage = __webpack_require__(50853);
;// CONCATENATED MODULE: ./src/components/skeleton/index.ts











/***/ }),

/***/ 35861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Products; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(27948);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(40549);
/* harmony import */ var _hooks_useSettings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10901);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67918);
/* harmony import */ var _hooks_useApp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28821);
/* harmony import */ var _hooks_useResponsive__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(10653);
/* harmony import */ var _hooks_useCollapseDrawer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67854);
/* harmony import */ var _layouts_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72575);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61582);
/* harmony import */ var _components_skeleton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96339);
/* harmony import */ var _sections_e_commerce_shop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21340);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25168);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _sections_e_commerce_shop_ShopProductSort__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59012);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86704);







// @mui


// hooks





// layouts

// components


// sections





// ----------------------------------------------------------------------
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
        paddingTop: theme.spacing(8)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(11)
    });
});
var MainStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP)("main", {
    shouldForwardProp: function(prop) {
        return prop !== "collapseClick";
    }
})(function(param) {
    var collapseClick = param.collapseClick, theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
        flexGrow: 1,
        paddingTop: 24,
        paddingBottom: _config__WEBPACK_IMPORTED_MODULE_14__/* .HEADER.MOBILE_HEIGHT */ .yf.MOBILE_HEIGHT + 24
    }, theme.breakpoints.up("lg"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: _config__WEBPACK_IMPORTED_MODULE_14__/* .HEADER.DASHBOARD_DESKTOP_HEIGHT */ .yf.DASHBOARD_DESKTOP_HEIGHT + 24,
        width: "calc(100% - ".concat(_config__WEBPACK_IMPORTED_MODULE_14__/* .NAVBAR.DASHBOARD_WIDTH */ .Au.DASHBOARD_WIDTH, "px)"),
        transition: theme.transitions.create("margin-left", {
            duration: theme.transitions.duration.shorter
        })
    }, collapseClick && {
        marginLeft: _config__WEBPACK_IMPORTED_MODULE_14__/* .NAVBAR.DASHBOARD_COLLAPSE_WIDTH */ .Au.DASHBOARD_COLLAPSE_WIDTH
    }));
});
// ----------------------------------------------------------------------
Products.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_index__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
// ----------------------------------------------------------------------
var DEFAULT_PRODUCTS_ORDERS = _generated_graphql__WEBPACK_IMPORTED_MODULE_11__/* .ProductsOrder.SysPublishedAtDesc */ .OEG.SysPublishedAtDesc;
var __N_SSG = true;
function Products(param) {
    var _allProducts = param.allProducts, allProducts = _allProducts === void 0 ? [] : _allProducts, _allSearchTags = param.allSearchTags, allSearchTags = _allSearchTags === void 0 ? [] : _allSearchTags, _totalProducts = param.totalProducts, totalProducts = _totalProducts === void 0 ? 0 : _totalProducts;
    var ref;
    var themeStretch = (0,_hooks_useSettings__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().themeStretch;
    var ref1 = (0,_hooks_useCollapseDrawer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), collapseClick = ref1.collapseClick, isCollapse = ref1.isCollapse;
    var isDesktop = (0,_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)("up", "lg");
    var ref2 = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), locale = ref2.locale, query = ref2.query;
    var ref3 = (0,_hooks_useApp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), logo = ref3.logo, host = ref3.host;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openFilter = ref4[0], setOpenFilter = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        search: null,
        tagIds: null,
        sortBy: null
    }), filter = ref5[0], setFilter = ref5[1];
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().translate;
    var _search, ref6;
    var querySearch = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var ref;
        return {
            search: Array.isArray(query.search) ? "" : (_search = query.search) !== null && _search !== void 0 ? _search : "",
            tagIds: !Array.isArray(query.tags) ? (ref6 = (ref = query.tags) === null || ref === void 0 ? void 0 : ref.split("|").map(function(tag) {
                return tag.split("_")[0];
            }).filter(function(tagIdParam) {
                return lodash_find__WEBPACK_IMPORTED_MODULE_12___default()(allSearchTags, {
                    sys: {
                        id: tagIdParam
                    }
                });
            })) !== null && ref6 !== void 0 ? ref6 : [] : [],
            sortBy: Array.isArray(query.sort) ? DEFAULT_PRODUCTS_ORDERS : query.sort ? Object.values(_generated_graphql__WEBPACK_IMPORTED_MODULE_11__/* .ProductsOrder */ .OEG).includes(query.sort) ? query.sort : DEFAULT_PRODUCTS_ORDERS : DEFAULT_PRODUCTS_ORDERS
        };
    }, [
        query,
        allSearchTags
    ]);
    var _search1, _tagIds, _sortBy;
    var combinedFilter = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            search: (_search1 = filter.search) !== null && _search1 !== void 0 ? _search1 : querySearch.search,
            tagIds: (_tagIds = filter.tagIds) !== null && _tagIds !== void 0 ? _tagIds : querySearch.tagIds,
            sortBy: (_sortBy = filter.sortBy) !== null && _sortBy !== void 0 ? _sortBy : querySearch.sortBy
        };
    }, [
        filter,
        querySearch
    ]);
    var filteredProducts = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return allProducts.sort(function(a, b) {
            switch(combinedFilter.sortBy){
                case _generated_graphql__WEBPACK_IMPORTED_MODULE_11__/* .ProductsOrder.SysPublishedAtAsc */ .OEG.SysPublishedAtAsc:
                    return new Date(a.publishedAt).getTime() - new Date(b.publishedAt).getTime();
                case _generated_graphql__WEBPACK_IMPORTED_MODULE_11__/* .ProductsOrder.PriceAsc */ .OEG.PriceAsc:
                    var _price, _price1;
                    return ((_price = a.price) !== null && _price !== void 0 ? _price : 0) - ((_price1 = b.price) !== null && _price1 !== void 0 ? _price1 : 0);
                case _generated_graphql__WEBPACK_IMPORTED_MODULE_11__/* .ProductsOrder.PriceDesc */ .OEG.PriceDesc:
                    var _price2, _price3;
                    return ((_price2 = b.price) !== null && _price2 !== void 0 ? _price2 : 0) - ((_price3 = a.price) !== null && _price3 !== void 0 ? _price3 : 0);
                case _generated_graphql__WEBPACK_IMPORTED_MODULE_11__/* .ProductsOrder.TitleAsc */ .OEG.TitleAsc:
                    if (a.title.toLowerCase() > b.title.toLowerCase()) return 1;
                    if (a.title.toLowerCase() < b.title.toLowerCase()) return -1;
                    else return 0;
                case _generated_graphql__WEBPACK_IMPORTED_MODULE_11__/* .ProductsOrder.TitleDesc */ .OEG.TitleDesc:
                    if (b.title.toLowerCase() > a.title.toLowerCase()) return 1;
                    if (b.title.toLowerCase() < a.title.toLowerCase()) return -1;
                    else return 0;
                default:
                    return new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime();
            }
        }).filter(function(product) {
            if (combinedFilter.tagIds.length && combinedFilter.search) {
                return product.tags.some(function(tag) {
                    return combinedFilter.tagIds.includes(tag.id);
                }) && (product.title.toLowerCase().includes(combinedFilter.search.toLowerCase()) || product.abstract.toLowerCase().includes(combinedFilter.search.toLowerCase()) || product.tags.find(function(tag) {
                    return tag.name.toLowerCase().includes(combinedFilter.search.toLowerCase());
                }));
            }
            if (combinedFilter.search) {
                return product.title.toLowerCase().includes(combinedFilter.search.toLowerCase()) || product.abstract.toLowerCase().includes(combinedFilter.search.toLowerCase()) || product.tags.find(function(tag) {
                    return tag.name.toLowerCase().includes(combinedFilter.search.toLowerCase());
                });
            }
            if (combinedFilter.tagIds.length) {
                return product.tags.some(function(tag) {
                    return combinedFilter.tagIds.includes(tag.id);
                });
            }
            return true;
        });
    }, [
        allProducts,
        combinedFilter
    ]);
    var handleOpenFilter = function() {
        setOpenFilter(true);
    };
    var handleCloseFilter = function() {
        setOpenFilter(false);
    };
    var handleResetFilter = function() {
        setFilter(function(prev) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, prev), {
                tagIds: []
            });
        });
        handleCloseFilter();
    };
    var renderContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                spacing: 2,
                direction: {
                    xs: "column",
                    sm: "row"
                },
                alignItems: {
                    sm: "center"
                },
                justifyContent: "space-between",
                sx: {
                    mb: 5,
                    mt: 3
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_e_commerce_shop__WEBPACK_IMPORTED_MODULE_10__/* .ShopProductSearch */ .W, {
                        value: combinedFilter.search,
                        onSearch: function(value) {
                            return setFilter(function(prev) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, prev), {
                                    search: value
                                });
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        direction: "row",
                        spacing: 1,
                        sx: {
                            my: 1
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_e_commerce_shop__WEBPACK_IMPORTED_MODULE_10__/* .ShopProductSort */ .a5, {
                            forPage: _sections_e_commerce_shop_ShopProductSort__WEBPACK_IMPORTED_MODULE_13__/* .ShopProductSortForPage.product */ .ZW.product,
                            value: combinedFilter.sortBy,
                            onSort: function(value) {
                                return setFilter(function(prev) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, prev), {
                                        sortBy: value
                                    });
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                sx: {
                    mb: 3
                },
                children: Boolean((ref = combinedFilter.tagIds) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            variant: "body2",
                            gutterBottom: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    children: filteredProducts.length
                                }),
                                "\xa0Products found"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_e_commerce_shop__WEBPACK_IMPORTED_MODULE_10__/* .ShopTagFiltered */ .vc, {
                            allSearchTags: allSearchTags,
                            filters: {
                                tagIds: combinedFilter.tagIds
                            },
                            onRemoveTagId: function(id) {
                                return setFilter(function(prevFilter) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, prevFilter), {
                                        tagIds: prevFilter.tagIds ? prevFilter.tagIds.filter(function(tagId) {
                                            return tagId !== id;
                                        }) : combinedFilter.tagIds.filter(function(tagId) {
                                            return tagId !== id;
                                        })
                                    });
                                });
                            },
                            onResetAll: handleResetFilter
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                sx: {
                    display: "grid",
                    gap: 3,
                    gridTemplateColumns: {
                        xs: "repeat(1, 1fr)",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(3, 1fr)",
                        lg: "repeat(4, 1fr)"
                    }
                },
                children: filteredProducts.map(function(product, index) {
                    return product ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_e_commerce_shop__WEBPACK_IMPORTED_MODULE_10__/* .ShopProductCard */ .a8, {
                        product: product
                    }, product.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_skeleton__WEBPACK_IMPORTED_MODULE_9__/* .SkeletonProductItem */ .JJ, {}, index);
                })
            })
        ]
    });
    var _previewUrl;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        title: translate("common.product"),
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "ProductCollection",
            name: translate("common.product"),
            description: "A collection products.",
            url: "https://".concat(host, "/").concat(locale, "/products"),
            image: logo !== null && logo !== void 0 ? logo : "",
            includesObject: filteredProducts.map(function(filteredProduct) {
                return {
                    "@type": "Product",
                    "@id": filteredProduct.id,
                    name: filteredProduct.title,
                    image: (_previewUrl = filteredProduct.previewUrl) !== null && _previewUrl !== void 0 ? _previewUrl : "",
                    description: filteredProduct.abstract,
                    url: "https://".concat(host, "/").concat(locale, "/product/").concat(filteredProduct.slug)
                };
            })
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootStyle, {
            children: isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                sx: {
                    display: {
                        lg: "flex"
                    },
                    minHeight: {
                        lg: 1
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_e_commerce_shop__WEBPACK_IMPORTED_MODULE_10__/* .ShopFilterSidebar */ .n4, {
                        filteredTagIds: combinedFilter.tagIds,
                        filterTags: allSearchTags,
                        onAddTagId: function(id) {
                            return setFilter(function(prevFilter) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, prevFilter), {
                                    tagIds: prevFilter.tagIds ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(prevFilter.tagIds).concat([
                                        id
                                    ]) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(combinedFilter.tagIds).concat([
                                        id
                                    ])
                                });
                            });
                        },
                        onRemoveTagId: function(id) {
                            return setFilter(function(prevFilter) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, prevFilter), {
                                    tagIds: prevFilter.tagIds ? prevFilter.tagIds.filter(function(tagId) {
                                        return tagId !== id;
                                    }) : combinedFilter.tagIds.filter(function(tagId) {
                                        return tagId !== id;
                                    })
                                });
                            });
                        },
                        onResetAll: handleResetFilter,
                        isOpen: openFilter,
                        onOpen: handleOpenFilter,
                        onClose: handleCloseFilter
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MainStyle, {
                        collapseClick: collapseClick,
                        children: renderContent
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_e_commerce_shop__WEBPACK_IMPORTED_MODULE_10__/* .ShopFilterTopBar */ .wk, {
                        filteredTagIds: combinedFilter.tagIds,
                        filterTags: allSearchTags,
                        onAddTagId: function(id) {
                            return setFilter(function(prevFilter) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, prevFilter), {
                                    tagIds: prevFilter.tagIds ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(prevFilter.tagIds).concat([
                                        id
                                    ]) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(combinedFilter.tagIds).concat([
                                        id
                                    ])
                                });
                            });
                        },
                        onRemoveTagId: function(id) {
                            return setFilter(function(prevFilter) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, prevFilter), {
                                    tagIds: prevFilter.tagIds ? prevFilter.tagIds.filter(function(tagId) {
                                        return tagId !== id;
                                    }) : combinedFilter.tagIds.filter(function(tagId) {
                                        return tagId !== id;
                                    })
                                });
                            });
                        },
                        onResetAll: handleResetFilter,
                        isOpen: openFilter,
                        onOpen: handleOpenFilter,
                        onClose: handleCloseFilter
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                        maxWidth: themeStretch ? false : "lg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                            component: "main",
                            sx: {
                                px: {
                                    lg: 2
                                },
                                pt: {
                                    xs: "".concat(_config__WEBPACK_IMPORTED_MODULE_14__/* .HEADER.MOBILE_HEIGHT */ .yf.MOBILE_HEIGHT + 24, "px"),
                                    lg: "".concat(_config__WEBPACK_IMPORTED_MODULE_14__/* .HEADER.DASHBOARD_DESKTOP_HEIGHT */ .yf.DASHBOARD_DESKTOP_HEIGHT + 80, "px")
                                },
                                pb: {
                                    xs: "".concat(_config__WEBPACK_IMPORTED_MODULE_14__/* .HEADER.MOBILE_HEIGHT */ .yf.MOBILE_HEIGHT + 24, "px"),
                                    lg: "".concat(_config__WEBPACK_IMPORTED_MODULE_14__/* .HEADER.DASHBOARD_DESKTOP_HEIGHT */ .yf.DASHBOARD_DESKTOP_HEIGHT + 24, "px")
                                }
                            },
                            children: renderContent
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 13162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ fNumber; },
/* harmony export */   "e_": function() { return /* binding */ fCurrency; }
/* harmony export */ });
/* unused harmony exports fPercent, fShortenNumber, fData */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);

// ----------------------------------------------------------------------
function fCurrency(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(Number.isInteger(number) ? "$0,0" : "$0,0.00");
}
function fPercent(number) {
    return numeral(number / 100).format("0.0%");
}
function fNumber(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format();
}
function fShortenNumber(number) {
    return numeral(number).format("0.00a").replace(".00", "");
}
function fData(number) {
    return numeral(number).format("0.0 b");
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6547,513,9694,1664,9463,7952,4894,1997,2679,2077,5644,3895,8424,6755,3907,2575,1340,9774,2888,179], function() { return __webpack_exec__(76502); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);